export default __webpack_public_path__ + "static/media/defient_carousel_2.png.webp";